import type React from 'react';

import classNames from 'classnames';

import type { AssetsApprovalBySchema } from '@iconik-io/iconik-api/src/services/assets';
import { Icon } from '@iconik-io/uad';

import type { StatusTooltipComponent } from './status_tooltip';

import styles from '../approval_detailed_status_icon.module.css';

export const FailureStatuses: React.FC<{
  rejectedBy: AssetsApprovalBySchema[];
  rejectedByUser: boolean;
  StatusTooltip: StatusTooltipComponent;
}> = ({ rejectedBy, rejectedByUser, StatusTooltip }) => {
  const statuses = [];

  if (rejectedBy.length > 0) {
    statuses.push(
      <div key="rejected-status" className={styles.status_content}>
        <StatusTooltip label={rejectedByUser ? 'Rejected by you' : 'Rejected'}>
          <div className={styles.status_icon}>
            <Icon name={rejectedByUser ? 'ra_rejected_by_me' : 'ra_rejected'} />
          </div>
        </StatusTooltip>
        {rejectedBy.length > 1 ? (
          <div className={styles.counter}>{rejectedBy.length}</div>
        ) : null}
      </div>,
    );
  }

  if (statuses.length > 0) {
    return (
      <div className={classNames(styles.status_fail, styles.status)}>
        {statuses}
      </div>
    );
  }
  return null;
};
